import camelCase from 'lodash/camelCase'
import mapKeys from 'lodash/mapKeys'
import get from 'lodash/get'
import snakeCase from 'lodash/snakeCase'
import {initialState} from './index'
import {formatPhone, formatZip} from '../../components/Forms/helpers'

export const prependFormName = (formSectionName, key) => `${formSectionName}_${key}`

export const normalizeFormValues = (formSectionName, values) => ({
  ...initialState[`${formSectionName}Address`],
  ...mapKeys(get(values, `${formSectionName}.address`), (_, key) => key),
})

export const denormalizeFormValues = (formSectionName, values) => ({
  ...mapKeys(initialState[`${formSectionName}Address`], (_, key) =>
    prependFormName('billing', snakeCase(key)),
  ),
  ...mapKeys(get(values, `${formSectionName}.address`), (_, key) =>
    prependFormName(formSectionName, snakeCase(key)),
  ),
})

export function formatAddressValues(addressType, addressValues) {
  const ret = mapKeys(addressValues, (_, key) => camelCase(key.replace(`${addressType}_`, '')))
  if (ret.phone) {
    ret.phone = formatPhone(ret.phone)
  }
  if (ret.zip) {
    ret.zip = formatZip(ret.zip)
  }
  return ret
}
